/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface FileNameInfoDto
 */
export interface FileNameInfoDto {
    /**
     * 
     * @type {string}
     * @memberof FileNameInfoDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileNameInfoDto
     */
    $type?: FileNameInfoDtoTypeEnum;
}


/**
 * @export
 */
export const FileNameInfoDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedCommonFileNameInfoDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Common.FileNameInfoDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type FileNameInfoDtoTypeEnum = typeof FileNameInfoDtoTypeEnum[keyof typeof FileNameInfoDtoTypeEnum];


/**
 * Check if a given object implements the FileNameInfoDto interface.
 */
export function instanceOfFileNameInfoDto(value?: unknown): value is FileNameInfoDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(FileNameInfoDtoTypeEnum)[0];
}

export function FileNameInfoDtoFromJSON(json: any): FileNameInfoDto {
    return FileNameInfoDtoFromJSONTyped(json, false);
}

export function FileNameInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileNameInfoDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function FileNameInfoDtoToJSON(value?: FileNameInfoDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'name': value.name,
        '$type': value.$type,
    });
}

